<template>
  <div>
    <div class="VV_DocumentRow d-flex py-2">
      <div class="mr-4"
           v-if="showImages">
        <DocumentThumbnail :connection="connection"
                           :document="document"
                           @click.prevent="dialog = true">
        </DocumentThumbnail>
      </div>
      <div class="flex-grow-1">
        <div>
          <FileTypeIcon :document="document"
                        class="mr-2">
          </FileTypeIcon>
          <a :href="document.url"
             @click.prevent="dialog = true">
            <template v-if="showVersion">
              {{ name }} {{ version }}
            </template>
            <template v-else>
              {{ name }}
            </template>
          </a>

          <a v-if="document.url"
             :href="document.url"
             target="_blank"
             class="ml-2">
            <v-icon small>
              fal fa-fw fa-external-link
            </v-icon>
          </a>
        </div>
        <div v-if="isDemo"
             class="d-flex text-caption">
          <div>
            ID: 123456789
          </div>
        </div>
        <div v-else
             class="d-flex text-caption">
          <div class="text-nowrap">
            ID: {{ document.document_id }}
            <a href="#clipboard" @click.prevent="copyToClipboard(document.document_id)">
              <v-icon x-small>
                fal fa-fw fa-copy
              </v-icon>
            </a>
          </div>
        </div>
        <div class="d-flex text-caption">
          <div>
            State: {{ document.state_display }}
          </div>
        </div>
        <div class="d-flex text-caption">
          <div>
            Current Version: {{ document.is_current_version ? 'Yes' : 'No' }}
          </div>
        </div>
        <div v-if="isDemo"
             class="d-flex text-caption">
          <div class="text-nowrap">
            Language: [TBD]
          </div>
        </div>
        <div v-else
             class="d-flex text-caption">
          <div>
            Language: {{ document.language }}
          </div>
        </div>
        <div v-if="isDemo"
             class="d-flex text-caption">
          <div class="text-nowrap">
            Content Type: [Scientific]
          </div>
        </div>
        <div v-else
             class="d-flex text-caption">
          <div>
            Content Type: {{ document.content_type }}
          </div>
        </div>
        <div v-if="isDemo"
             class="d-flex text-caption">
          <div class="text-nowrap">
            Classification: [Scientific]
          </div>
        </div>
        <div v-else
             class="d-flex text-caption">
          <div>
            Classification: {{ document.content_classification }}
          </div>
        </div>
        <div v-if="isDemo"
             class="d-flex text-caption">
          <div class="text-nowrap">
            Material Type: [TBD]
          </div>
        </div>
        <div v-else
             class="d-flex text-caption">
          <div>
            Material Type: {{ document.material_type }}
          </div>
        </div>
        <div v-if="isDemo"
             class="d-flex text-caption">
          <div class="text-nowrap">
            Document Subtype: [TBD]
          </div>
        </div>
        <div v-else
             class="d-flex text-caption">
          <div>
            Document Subtype: {{ document.document_subtype }}
          </div>
        </div>
        <div v-if="isDemo"
             class="d-flex text-caption">
          <div class="text-nowrap">
            Products: [TBD]
          </div>
        </div>
        <div v-else
             class="d-flex text-caption">
          <div>
            Products: {{ document.products ?? 'None' }}
          </div>
        </div>
      </div>
      <div>
        <div class="text-caption">
          <div class="text-right text-no-wrap">
            {{ document.status__v }}
          </div>
          <div v-if="expirationDate"
               class="text-right text-nowrap">
            Expires: {{ expirationDate | datetime('MMM D, YYYY') }}
          </div>
          <div v-else
               class="text-right text-nowrap">
            No expiration date
          </div>
        </div>
        <div>
          <div class="mt-1">
            <v-btn @click.prevent="addToCart"
                   v-if="!inCart"
                   x-small
                   block
                   color="primary">
              Add to cart
            </v-btn>
            <v-btn @click.prevent="removeFromCart"
                   v-else
                   x-small
                   block
                   color="primary">
              Remove from cart
            </v-btn>

            <v-btn v-if="1===2"
                   :href="downloadURL"
                   target="_blank"
                   x-small
                   block
                   :disabled="!canDownload">
              Download
            </v-btn>

            <v-btn type="button"
                   x-small
                   block
                   @click.prevent="expanded = !expanded"
                   class="mt-2">
              {{ expanded ? 'Hide' : 'Expand' }}
            </v-btn>
          </div>
        </div>
      </div>
    </div>
    <div v-if="expanded">
      <pre>{{ document }}</pre>
    </div>

    <v-dialog v-model="dialog"
              class="VV_DocumentDialog"
              width="90%">
      <v-card class="VV_DocumentDialogCard">
        <v-card-title>

        </v-card-title>
        <v-card-text>
          <codemirror-json :code="JSON.stringify(document, null, 2)"
                           :options="{lineNumbers: true, lineWrapping: true, mode: 'javascript', readOnly: true, theme: 'monokai'}">
          </codemirror-json>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<style lang="scss">
.VV_DocumentDialogCard {
  .CodeMirror {
    height: 500px;
  }
}
</style>
<script>
import {mapGetters} from 'vuex';
import {find} from 'lodash';
import DocumentThumbnail from './DocumentThumbnail';
import FileTypeIcon from './FileTypeIcon';
import pepperFlowService from '../../../services/pepperFlowService';
import CodemirrorJson from './CodeMirrorJson';
import clipboardService from '../../../../../ml/services/clipboardService';

export default {
  components: {CodemirrorJson, FileTypeIcon, DocumentThumbnail},
  props: {
    connection: {
      type: String,
      required: true,
    },
    document: {
      type: Object,
      required: true,
    },
    showImages: {
      type: Boolean,
      default: false,
    },
    showVersion: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: false,
      expanded: false,
    }
  },
  computed: {
    ...mapGetters('pepperFlowCart', [
      'documents',
    ]),
    ...mapGetters('pepperFlow', [
      'connections',
    ]),
    isDemo() { // MLD-2944
      return this.connection === 'demo_vault';
    },
    inCart() {
      const doc = find(this.documents, d => d.id === this.document.id);
      return !!doc;
    },
    version() {
      return `(v${this.document.version})`
    },
    name() {
      if (this.isDemo && this.document.display_name) { // MLD-2944
        return `*********************${this.document.display_name.slice(this.document.display_name.length - 4)}`
      }
      return this.document.display_name;
    },
    title() { // MLD-2944
      if (this.isDemo) {
        if (this.document.display_name) {
          return `*********************${this.document.display_name.slice(this.document.display_name.length - 4)}`
        } else if (this.document.filename) {
          return `*********************${this.document.filename.slice(this.document.filename.length - 4)}`
        } else {
          return `*********************`;
        }
      }
      return this.document.display_name;
    },
    expirationDate() {
      if (this.document.expiration_date) {
        return this.document.expiration_date;
      }
      return null;
    },
    isApproved() {
      return this.document.is_approved;
    },
    canDownload() {
      return this.isApproved;
    },
    downloadURL() {
      return this.document.url;
    }
  },
  methods: {
    toggleCart() {
      if (this.inCart) {
        this.removeFromCart();
      } else {
        this.addToCart();
      }
    },
    addToCart() {
      this.$store.dispatch('pepperFlowCart/addDocument', this.document);
    },
    removeFromCart() {
      this.$store.dispatch('pepperFlowCart/removeDocument', this.document);
    },
    download() {
      pepperFlowService.downloadDocument(this.connection, this.document.id);
    },
    copyToClipboard(text) {
      clipboardService.copy(text, false)
        .then(() => {
          this.$toast.success('Copied to clipboard.');
        })
    }
  }
}
</script>
